module.exports = __webpack_public_path__ + "img/tj.9853139.svg";